export default __webpack_public_path__ + "static/media/search.d6cc76d3.svg";